import { createAction } from "@coverme/redux";
import Axios from "axios";

export const searchCustomerByCallCenterCode = code =>
    createAction("GET_CUSTOMER", () =>
        Axios.get(`api/customer/callcenter/${code}`)
            .then(x => x.data)
            .catch(error => {
                if (error.response.status === 404) {
                    return null;
                } else {
                    throw error;
                }
            })
    );
